import React from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from "wc-toast";
import { GlobalStyles } from "./css/globalStyle";
import Header from "./componant/header";
import Footer from "./componant/footer";
import Router from "./routers/RouterConfig";
import Sidebar from "./componant/sidebar";
import PullToRefreshWrapper from './componant/PullToRefreshWrapper';


function AppContent() {
  const location = useLocation();
  const isHome = location.pathname === '/'
  const isGoTruckPage = location.pathname.toLowerCase() === '/gotruck'; // GoTruck 페이지 경로 확인
  const isMainPage = 
    // location.pathname === '/' ||  
    location.pathname === '/login' ||
    location.pathname === '/signup' ||
    location.pathname === '/RegularUser' ||
    location.pathname === '/signup-regularuser' ||
    location.pathname === '/CorporationUser' ||
    location.pathname === '/signup-form1corporationuser' ||
    location.pathname === '/signup-form2corporationuser';

  const handleRefresh = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        window.location.reload();
        resolve();
      }, 500);
    });
  };

  return (
    <>
      <wc-toast></wc-toast>
      <GlobalStyles />
      {!isGoTruckPage && <Header />}
      <PullToRefreshWrapper onRefresh={handleRefresh}>
      <Router />
      </PullToRefreshWrapper>
      {/* <Sidebar /> */}
      {isHome && !isGoTruckPage && <Sidebar />}
      {!isHome && !isMainPage && !isGoTruckPage && <Sidebar isAllView/>}
      {!isGoTruckPage && <Footer />}
    </>
  );
}

export default AppContent;
